import {BaseService} from "./base.service";

class RelservpackService extends BaseService {

    constructor() {
        super('api/rel-serv-pack')
    }

    getRelServPackByPkgId(params) {
        return this.http.post(`api/rel-serv-pack-by-id`, {params}).then(response => response.data).catch(err => err.message);
    }

}

export const relservpackService = new RelservpackService();
